export function mapBanners(banners) {
    const mappedBanners = {
        desktop: [],
        mobile: [],
    };
    banners.forEach(banner => {
        var _a, _b, _c, _d, _e, _f;
        mappedBanners.desktop.push({
            url: banner.url,
            alt: banner.altText,
            imageId: (_a = banner.desktopImage) === null || _a === void 0 ? void 0 : _a.id,
            slotName: banner.slotName,
            adSlot: (_b = banner.adSlots) === null || _b === void 0 ? void 0 : _b.desktop,
        });
        mappedBanners.mobile.push({
            url: banner.url,
            alt: banner.altText,
            imageId: (_d = (_c = banner.mobileImage) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : (_e = banner.desktopImage) === null || _e === void 0 ? void 0 : _e.id,
            slotName: banner.slotName,
            adSlot: (_f = banner.adSlots) === null || _f === void 0 ? void 0 : _f.mobile,
        });
    });
    return mappedBanners;
}
//# sourceMappingURL=mapBanners.js.map